// src/components/Globe/UserProfile.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserProfile.css';

const UserProfile = ({ userEmail, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Extrair iniciais do email
  const getInitials = (email) => {
    if (!email) return 'US';
    const parts = email.split('@')[0].split('.');
    return (parts[0][0] + (parts[1]?.[0] || parts[0][1] || '')).toUpperCase();
  };

  // Extrair nome do email
  const getName = (email) => {
    if (!email) return 'Usu&aacute;rio';
    const name = email.split('@')[0].replace(/[._-]/g, ' ');
    return name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const handleLogout = () => {
    setIsOpen(false);
    onLogout();
  };

  const initials = getInitials(userEmail);
  const userName = getName(userEmail);

  return (
    <div className="user-profile-container" ref={dropdownRef}>
      {/* Avatar com iniciais */}
      <button 
        className="user-profile-avatar"
        onClick={() => setIsOpen(!isOpen)}
        title={userEmail}
        aria-label="Menu do usu&aacute;rio"
      >
        <span className="avatar-initials">{initials}</span>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="user-profile-dropdown">
          {/* Header do dropdown */}
          <div className="dropdown-header">
            <div className="dropdown-avatar">
              <span className="avatar-initials-large">{initials}</span>
            </div>
            <div className="dropdown-info">
              <div className="user-name">{userName}</div>
              <div className="user-email-dropdown">{userEmail}</div>
            </div>
          </div>

          {/* Divisor */}
          <div className="dropdown-divider"></div>

          {/* Menu items */}
          <div className="dropdown-menu">
            <button className="dropdown-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              <span>Perfil</span>
            </button>
            
            <button className="dropdown-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="1"/>
                <circle cx="19" cy="12" r="1"/>
                <circle cx="5" cy="12" r="1"/>
              </svg>
              <span>Prefer&ecirc;ncias</span>
            </button>

            <button className="dropdown-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
              <span>Hist&oacute;rico</span>
            </button>
          </div>

          {/* Divisor */}
          <div className="dropdown-divider"></div>

          {/* Logout button */}
          <button 
            className="dropdown-item dropdown-logout"
            onClick={handleLogout}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            <span>Sair</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
